import { createSlice } from '@reduxjs/toolkit';

import { fetchCategoryRelatedSearchTiles } from './categoryRelatedSearches.actions';
import { defaultCategoryRelatedSearchTilesSlice } from './categoryRelatedSearches.types';

const categoryRelatedSearchTilesSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchCategoryRelatedSearchTiles.fulfilled, (state, { payload }) => {
            state.categoryRelatedSearchTiles = {
                relatedSearches: payload?.relatedSearches || [],
                relatedSearchPages: payload?.relatedSearchPages || [],
            };
        });
        builder.addCase(fetchCategoryRelatedSearchTiles.rejected, (state) => {
            state.categoryRelatedSearchTiles = {
                relatedSearches: [],
                relatedSearchPages: [],
            };
        });
    },
    initialState: defaultCategoryRelatedSearchTilesSlice,
    name: 'categoryRelatedSearchTiles',
    reducers: {},
});

export const { reducer: categoryRelatedSearchTilesReducer } = categoryRelatedSearchTilesSlice;
